import { useMgoClient } from '@mgonetwork/dapp-kit';
import { useQuery } from '@tanstack/react-query';

export function useNormalizedMoveModule(packageId?: string | null, moduleName?: string | null) {
	const client = useMgoClient();
	return useQuery({
		queryKey: ['normalized-module', packageId, moduleName],
		queryFn: async () =>
			await client.getNormalizedMoveModule({
				package: packageId!,
				module: moduleName!,
			}),
		enabled: !!(packageId && moduleName),
	});
}
